import { Box } from '@chakra-ui/react';
import leftArrow from '@public/assets/icons/control/left-arrow.svg';
import Image from 'next/image';
import Link from 'next/link';

const LeftArrow = ({ onClick = null, href = null, ...rest }) => {
  if (href) {
    return (
      <Link href={href}>
        <Box
          cursor="pointer"
          _hover={{ opacity: 0.5 }}
          transition="opacity ease 200ms"
          w={['26px', '26px', '35px', '35px']}
          {...rest}
        >
          <Image src={leftArrow} alt="Left Arrow" width={35} height={35} />
        </Box>
      </Link>
    );
  }

  return (
    <Box
      onClick={onClick}
      cursor="pointer"
      _hover={{ opacity: 0.5 }}
      transition="opacity ease 200ms"
      w={['26px', '26px', '35px', '35px']}
      minW={['26px', '26px', '35px', '35px']}
      {...rest}
    >
      <Image src={leftArrow} alt="Left Arrow" width={35} height={35} />
    </Box>
  );
};

export default LeftArrow;
